import { helperManager } from '../utils/Helper';
class IntranetAppManager {
    constructor() {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const isInWebAppiOS = (window.navigator.standalone === true);
        const isInWebAppChrome = (window.matchMedia('(display-mode: standalone)').matches);
        const isInWebApp = isInWebAppiOS || isInWebAppChrome;
        if (isInWebApp) {
            const logo = $('.Logo');
            const intranetUrl = logo.data('intranet-href');
            if (intranetUrl) {
                logo.attr('href', intranetUrl);
            }
            $('.AppNav').removeClass('Hidden');
            $('.AppNav_BackBtn').on('click', () => window.history.back());
        }
        const isIntranetApp = $('.js-IsIntranetApp');
        if (!isIntranetApp.length)
            return;
        const supportsServiceWorkers = 'serviceWorker' in navigator;
        if (!supportsServiceWorkers)
            return;
        const scope = isIntranetApp.data('scope');
        navigator.serviceWorker.register('/sw-intranet.js', {
            scope
        });
        const installInstranetAppAlert = $('.js-InstallIntranetAppAlert');
        if (!installInstranetAppAlert.length)
            return;
        if (isInWebApp || helperManager.intranetAppInstallHasBeenPrompted) {
            installInstranetAppAlert.remove(); // As long as the backend is bugged we can always remove the Alert clientside
            return;
        }
        const close = () => {
            installInstranetAppAlert.addClass('Faded');
            setTimeout(() => {
                installInstranetAppAlert.remove();
            }, 400);
            helperManager.intranetAppInstallHasBeenPrompted = true;
        };
        const closeBtn = installInstranetAppAlert.find('.js-CloseBtn');
        closeBtn.on('click', close);
        // Chrome detected
        const supportsInstallPrompt = typeof window.BeforeInstallPromptEvent === 'function';
        if (supportsInstallPrompt) {
            let deferredInstallPrompt;
            const installBtn = installInstranetAppAlert.find('.js-InstallBtn');
            installBtn.on('click', () => {
                deferredInstallPrompt.prompt();
                deferredInstallPrompt.userChoice.then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        close();
                    }
                });
            });
            window.addEventListener('beforeinstallprompt', (e) => {
                // Prevent the mini-infobar from appearing on mobile
                e.preventDefault();
                // Stash the event so it can be triggered later.
                deferredInstallPrompt = e;
                // Update UI notify the user they can install the PWA
                setTimeout(() => {
                    installBtn.removeClass('Hidden');
                    installInstranetAppAlert.removeClass('Hidden');
                }, 1000);
            });
        }
        else {
            const installLink = installInstranetAppAlert.find('.js-InstallLink');
            installLink.removeClass('Hidden');
            installLink.on('click', () => {
                close(); // Prevent next beforeinstallprompt from showing the install promotion again
            });
            installInstranetAppAlert.removeClass('Hidden');
        }
    }
}
const intranetAppManager = new IntranetAppManager();
window.intranetAppManager = intranetAppManager;
export { IntranetAppManager, intranetAppManager };
